import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import { useAuth } from '../context/AuthContext';

const CATEGORIAS = [
  { key:'senhas',     label:'Senhas e acessos',   emoji:'🔐', cor:'#9B7FD4' },
  { key:'documentos', label:'Documentos',          emoji:'📄', cor:'#6B2FA0' },
  { key:'materiais',  label:'Materiais de apoio',  emoji:'📚', cor:'#5BAD8F' },
  { key:'outros',     label:'Outros',              emoji:'📁', cor:'#E05454' },
];

const FORM_VAZIO = { titulo:'', categoria:'senhas', conteudo:'', tipo:'texto', link:'' };

export default function PlaybookCliente() {
  const { projetoId } = useParams();
  const navigate = useNavigate();
  const { usuario } = useAuth();
  const usuarioAtual = usuario?.nome || '';

  const [projeto, setProjeto] = useState(null);
  const [documentos, setDocumentos] = useState([]);
  const [carregando, setCarregando] = useState(true);
  const [docAberto, setDocAberto] = useState(null);
  const [modalNovo, setModalNovo] = useState(false);
  const [editandoDoc, setEditandoDoc] = useState(null);
  const [filtroCategoria, setFiltroCategoria] = useState('');
  const [form, setForm] = useState(FORM_VAZIO);
  const [migracaoAberta, setMigracaoAberta] = useState(false);
  const [playbookAntigo, setPlaybookAntigo] = useState(null);

  useEffect(() => { carregarTudo(); }, [projetoId]);

  async function carregarTudo() {
    setCarregando(true);
    const [{ data: p }, { data: docs }] = await Promise.all([
      supabase.from('projetos').select('id, nome, cor').eq('id', projetoId).single(),
      supabase.from('playbook_cliente').select('*').eq('projeto_id', projetoId).order('created_at', { ascending:false }),
    ]);
    setProjeto(p || null);
    setDocumentos(docs || []);
    setCarregando(false);
  }

  async function abrirMigracao() {
    setMigracaoAberta(true);
    if (playbookAntigo) return;
    const { data } = await supabase.from('playbook').select('id, titulo, conteudo, created_at').eq('categoria', 'senhas').order('titulo');
    setPlaybookAntigo(data || []);
  }

  function usarComoBase(doc) {
    setForm({ titulo: doc.titulo, categoria: 'senhas', conteudo: doc.conteudo || '', tipo: 'texto', link: '' });
    setEditandoDoc(null);
    setModalNovo(true);
  }

  const docsFiltrados = documentos.filter(d => !filtroCategoria || d.categoria === filtroCategoria);

  async function salvarDoc() {
    if (!form.titulo) return;
    const payload = { ...form, projeto_id: projetoId };
    if (editandoDoc) {
      const { data } = await supabase.from('playbook_cliente').update(payload).eq('id', editandoDoc.id).select().single();
      if (data) setDocumentos(documentos.map(d => d.id===editandoDoc.id?data:d));
    } else {
      const { data } = await supabase.from('playbook_cliente').insert([{ ...payload, criado_por: usuarioAtual }]).select().single();
      if (data) setDocumentos([data, ...documentos]);
    }
    setModalNovo(false); setEditandoDoc(null); setForm(FORM_VAZIO);
  }

  async function excluirDoc(doc) {
    if (!window.confirm(`Excluir "${doc.titulo}" do playbook do cliente?`)) return;
    const { error } = await supabase.from('playbook_cliente').delete().eq('id', doc.id);
    if (!error) { setDocumentos(documentos.filter(d => d.id !== doc.id)); setDocAberto(null); }
  }

  function abrirNovo() { setEditandoDoc(null); setForm(FORM_VAZIO); setModalNovo(true); }
  function abrirEditar(doc) { setEditandoDoc(doc); setForm({ titulo:doc.titulo, categoria:doc.categoria, conteudo:doc.conteudo||'', tipo:doc.tipo||'texto', link:doc.link||'' }); setModalNovo(true); setDocAberto(null); }

  const catConfig = (key) => CATEGORIAS.find(c=>c.key===key) || CATEGORIAS[3];

  if (carregando) return <div style={{ padding:40, textAlign:'center', color:'var(--gray-400)' }}>Carregando...</div>;
  if (!projeto) return <div style={{ padding:40, textAlign:'center', color:'var(--gray-400)' }}>Projeto não encontrado.</div>;

  return (
    <div>
      <div className="section-header">
        <button onClick={() => navigate('/projetos')} style={{ background:'transparent', border:'1px solid var(--border)', borderRadius:6, padding:'6px 12px', cursor:'pointer', fontSize:12, color:'var(--text-secondary)' }}>← Projetos</button>
        <h2 className="section-title">Playbook do Cliente — {projeto.nome}</h2>
        <div className="section-line" />
      </div>

      <p style={{ fontSize:12.5, color:'var(--text-secondary)', marginBottom:18 }}>
        Isso aparece na aba "Acessos" do portal deste projeto. É separado do playbook interno da equipe.
      </p>

      <div style={{ display:'flex', gap:8, marginBottom:20, flexWrap:'wrap', alignItems:'center' }}>
        <button onClick={()=>setFiltroCategoria('')} style={{ padding:'6px 14px', borderRadius:20, border:`1px solid ${!filtroCategoria?'var(--purple)':'var(--border)'}`, background:!filtroCategoria?'var(--purple)':'transparent', color:!filtroCategoria?'white':'var(--text-secondary)', cursor:'pointer', fontSize:12 }}>
          Todos ({documentos.length})
        </button>
        {CATEGORIAS.map(c => {
          const count = documentos.filter(d=>d.categoria===c.key).length;
          return <button key={c.key} onClick={()=>setFiltroCategoria(c.key)} style={{ padding:'6px 14px', borderRadius:20, border:`1px solid ${filtroCategoria===c.key?c.cor:'var(--border)'}`, background:filtroCategoria===c.key?c.cor:'transparent', color:filtroCategoria===c.key?'white':'var(--text-secondary)', cursor:'pointer', fontSize:12 }}>
            {c.emoji} {c.label} ({count})
          </button>;
        })}
        <div style={{ flex:1 }} />
        <button onClick={abrirMigracao} style={{ background:'transparent', border:'1px dashed var(--border)', color:'var(--text-secondary)', padding:'9px 16px', borderRadius:10, cursor:'pointer', fontSize:12.5 }}>
          📄 Migrar do playbook antigo
        </button>
        <button onClick={abrirNovo} style={{ background:'linear-gradient(135deg,#3F0051,#7B2FBE)', color:'white', border:'none', padding:'9px 22px', borderRadius:10, fontWeight:700, cursor:'pointer', fontSize:13, fontFamily:'Poppins,sans-serif' }}>
          + Novo item
        </button>
      </div>

      {migracaoAberta && (
        <div className="card" style={{ padding:18, marginBottom:20, background:'#FFFBEB', borderColor:'#C9A84C' }}>
          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:10 }}>
            <div style={{ fontSize:12.5, fontWeight:700, color:'#92400e' }}>
              📄 Playbook antigo (senhas) — pra referência. Ache o pedaço de {projeto.nome} aqui e clique em "Usar como base" pra copiar só o que for dele pra cá.
            </div>
            <button onClick={()=>setMigracaoAberta(false)} style={{ background:'transparent', border:'none', fontSize:18, cursor:'pointer', color:'#92400e' }}>×</button>
          </div>
          {!playbookAntigo && <div style={{ fontSize:12, color:'#92400e' }}>Carregando...</div>}
          {playbookAntigo?.length === 0 && <div style={{ fontSize:12, color:'#92400e' }}>Nenhum documento de senhas encontrado no playbook antigo.</div>}
          <div style={{ display:'flex', flexDirection:'column', gap:10, maxHeight:400, overflowY:'auto' }}>
            {playbookAntigo?.map(doc => (
              <div key={doc.id} style={{ background:'white', borderRadius:8, padding:'10px 14px', border:'1px solid #fde68a' }}>
                <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:6 }}>
                  <span style={{ fontWeight:700, fontSize:13, color:'var(--text-primary)' }}>{doc.titulo}</span>
                  <button onClick={()=>usarComoBase(doc)} style={{ background:'#92400e', color:'white', border:'none', padding:'4px 12px', borderRadius:6, cursor:'pointer', fontSize:11, fontWeight:600 }}>Usar como base →</button>
                </div>
                <pre style={{ margin:0, whiteSpace:'pre-wrap', fontFamily:'JetBrains Mono, monospace', fontSize:11.5, color:'var(--text-secondary)', maxHeight:120, overflowY:'auto' }}>{doc.conteudo}</pre>
              </div>
            ))}
          </div>
        </div>
      )}

      {docsFiltrados.length===0 && (
        <div className="card" style={{ padding:40, textAlign:'center', color:'var(--gray-400)' }}>
          Nada aqui ainda. Clique em "+ Novo item" pra adicionar uma senha, documento ou material desse cliente.
        </div>
      )}

      <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:14 }}>
        {docsFiltrados.map(doc => {
          const cat = catConfig(doc.categoria);
          return (
            <div key={doc.id} className="card" onClick={()=>setDocAberto(doc)}
              style={{ padding:20, cursor:'pointer', borderTop:`3px solid ${cat.cor}` }}>
              <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:10 }}>
                <span style={{ fontSize:24 }}>{cat.emoji}</span>
                <span style={{ background:cat.cor+'22', color:cat.cor, padding:'2px 8px', borderRadius:20, fontSize:10, fontWeight:700 }}>{cat.label}</span>
              </div>
              <div style={{ fontWeight:700, fontSize:14, color:'var(--text-primary)' }}>{doc.titulo}</div>
            </div>
          );
        })}
      </div>

      {/* Painel lateral */}
      {docAberto && (
        <div style={{ position:'fixed', inset:0, zIndex:1000, display:'flex' }}>
          <div style={{ flex:1, background:'rgba(0,0,0,0.4)' }} onClick={()=>setDocAberto(null)} />
          <div style={{ width:520, background:'#ffffff', borderLeft:'1px solid var(--border)', overflowY:'auto', padding:28 }}>
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:16 }}>
              <div>
                <div style={{ fontSize:11, color:catConfig(docAberto.categoria).cor, fontWeight:700, textTransform:'uppercase' }}>{catConfig(docAberto.categoria).emoji} {catConfig(docAberto.categoria).label}</div>
                <h3 style={{ margin:'4px 0 0', fontSize:17 }}>{docAberto.titulo}</h3>
              </div>
              <div style={{ display:'flex', gap:8 }}>
                <button onClick={()=>abrirEditar(docAberto)} style={{ background:'var(--purple)', color:'white', border:'none', padding:'6px 12px', borderRadius:6, cursor:'pointer', fontSize:12 }}>Editar</button>
                <button onClick={()=>excluirDoc(docAberto)} style={{ background:'#fee2e2', color:'#dc2626', border:'none', padding:'6px 12px', borderRadius:6, cursor:'pointer', fontSize:12 }}>Excluir</button>
                <button onClick={()=>setDocAberto(null)} style={{ background:'transparent', border:'none', fontSize:20, cursor:'pointer', color:'var(--gray-400)' }}>×</button>
              </div>
            </div>
            {docAberto.link && <a href={docAberto.link} target="_blank" rel="noreferrer" style={{ display:'block', marginBottom:14, color:'#4A90D9', fontSize:13, fontWeight:600 }}>🔗 Abrir link</a>}
            {docAberto.conteudo && <div style={{ fontSize:13, color:'var(--text-secondary)', whiteSpace:'pre-wrap', lineHeight:1.6 }}>{docAberto.conteudo}</div>}
          </div>
        </div>
      )}

      {/* Modal novo/editar */}
      {modalNovo && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:1100 }}>
          <div className="card" style={{ width:480, padding:32, maxHeight:'90vh', overflowY:'auto' }}>
            <div style={{ display:'flex', justifyContent:'space-between', marginBottom:20 }}>
              <h3 style={{ margin:0, color:'var(--purple)' }}>{editandoDoc?'Editar':'Novo'} item</h3>
              <button onClick={()=>setModalNovo(false)} style={{ background:'transparent', border:'none', fontSize:20, cursor:'pointer', color:'var(--gray-400)' }}>×</button>
            </div>
            <div style={{ marginBottom:14 }}>
              <label style={{ display:'block', fontSize:11, fontWeight:600, color:'var(--gray-400)', marginBottom:5, textTransform:'uppercase' }}>Título</label>
              <input value={form.titulo} onChange={e=>setForm({...form,titulo:e.target.value})}
                style={{ width:'100%', padding:'9px 12px', border:'1px solid var(--border)', borderRadius:6, fontSize:13, background:'var(--bg-secondary)', boxSizing:'border-box' }} />
            </div>
            <div style={{ marginBottom:14 }}>
              <label style={{ display:'block', fontSize:11, fontWeight:600, color:'var(--gray-400)', marginBottom:5, textTransform:'uppercase' }}>Categoria</label>
              <select value={form.categoria} onChange={e=>setForm({...form,categoria:e.target.value})}
                style={{ width:'100%', padding:'9px 12px', border:'1px solid var(--border)', borderRadius:6, fontSize:13, background:'var(--bg-secondary)' }}>
                {CATEGORIAS.map(c => <option key={c.key} value={c.key}>{c.emoji} {c.label}</option>)}
              </select>
            </div>
            <div style={{ marginBottom:14 }}>
              <label style={{ display:'block', fontSize:11, fontWeight:600, color:'var(--gray-400)', marginBottom:5, textTransform:'uppercase' }}>Conteúdo (login, senha, instruções...)</label>
              <textarea value={form.conteudo} onChange={e=>setForm({...form,conteudo:e.target.value})} rows={6}
                style={{ width:'100%', padding:'9px 12px', border:'1px solid var(--border)', borderRadius:6, fontSize:13, fontFamily:'monospace', background:'var(--bg-secondary)', boxSizing:'border-box', resize:'vertical' }} />
            </div>
            <div style={{ marginBottom:20 }}>
              <label style={{ display:'block', fontSize:11, fontWeight:600, color:'var(--gray-400)', marginBottom:5, textTransform:'uppercase' }}>Link externo (opcional)</label>
              <input value={form.link} onChange={e=>setForm({...form,link:e.target.value})} placeholder="https://..."
                style={{ width:'100%', padding:'9px 12px', border:'1px solid var(--border)', borderRadius:6, fontSize:13, background:'var(--bg-secondary)', boxSizing:'border-box' }} />
            </div>
            <div style={{ display:'flex', gap:10 }}>
              <button onClick={salvarDoc} style={{ flex:1, background:'var(--purple)', color:'white', border:'none', padding:'11px', borderRadius:7, fontWeight:700, cursor:'pointer', fontSize:14 }}>Salvar</button>
              <button onClick={()=>setModalNovo(false)} style={{ flex:1, background:'transparent', border:'1px solid var(--border)', padding:'11px', borderRadius:7, cursor:'pointer', color:'var(--text-secondary)', fontSize:14 }}>Cancelar</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
